import { render, staticRenderFns } from "./otherUserProfile.vue?vue&type=template&id=f7ebb680&scoped=true&"
import script from "./otherUserProfile.vue?vue&type=script&lang=js&"
export * from "./otherUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./otherUserProfile.vue?vue&type=style&index=0&id=f7ebb680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ebb680",
  null
  
)

export default component.exports